import React from 'react';

const Logo = ({ className = "logo-icon", size = 32 }) => {
    const cmsLogoUrl = process.env.REACT_APP_CMS_MEDIA_URL
        ? `${process.env.REACT_APP_CMS_MEDIA_URL}/adjactive_logo_copy_eebbfe22a6.png`
        : (process.env.REACT_APP_CMS_URL
            ? `${process.env.REACT_APP_CMS_URL}/uploads/adjactive_logo_copy_eebbfe22a6.png`
            : null);

    const fallbackLogo = `${process.env.PUBLIC_URL}/adjactive-logo.png`;

    return (
        <img
            src={cmsLogoUrl || fallbackLogo}
            alt="Adjactive Logo"
            className={className}
            style={{ width: size, height: 'auto', objectFit: 'contain' }}
            onError={(e) => {
                e.target.onerror = null;
                e.target.src = fallbackLogo;
            }}
        />
    );
};

export default Logo;
